import { NavLink } from "react-router-dom";
import { MenuLink } from "../../interface/bcmenulink";
import BcIcon from "../Bc-Icon/Bc-icon";

const BcMenuLink = ({ label, iconLink, path }: MenuLink) => {
  return (
    <NavLink className={({isActive}: any)=> isActive ? 'bc-menu-item-active': 'bc-menu-item'} aria-label={label} to={path}>
      <li>
        <BcIcon iconName={iconLink} />
        <div><span>{label}</span></div>
      </li>
    </NavLink>
  );
};

export default BcMenuLink;
